module.exports = __webpack_public_path__ + "img/售后.png";